<template>
	<section>
		<h2>Abbiamo collaborato con</h2>

		<SliderQ
            :minSizeOfSlide="80"
            :maxNumSlides='10'
            v-if="partners"
            isCentered
            class="container-slider"
        >
        	<slide
        		v-for="(item, index) in partners"
        	>
        		<div class="flex flex-vcenter slide">
        			<img :src="item.img" :alt='item.name' width="100px">
        		</div>
			</slide>
    	</SliderQ>
	</section>
</template>

<script>

export default {

	data () {
		return {
			partners: [
				{ name: 'Barilla', img: require('../../assets/img/partners/barilla.png') },
				{ name: 'Buttoni', img: require('../../assets/img/partners/buttoni.png') },
				{ name: 'Fastweb', img: require('../../assets/img/partners/fastweb.png') },
				{ name: 'Ing', img: require('../../assets/img/partners/ing.png') },
				{ name: 'Mediolanum', img: require('../../assets/img/partners/mediolanum.png') },
				{ name: 'Nexi', img: require('../../assets/img/partners/nexi.png') },
				{ name: 'Perugina', img: require('../../assets/img/partners/perugina.png') },
				{ name: 'Vitsnella', img: require('../../assets/img/partners/vitsnella.png') },
				{ name: 'Vodafone', img: require('../../assets/img/partners/vodafone.png') },
				{ name: 'Electrolux', img: require('../../assets/img/partners/electrolux.webp') }
			]
		}
	}
}
</script>

<style scoped>
h2 {
	text-align: center;
}

section {
	padding-bottom: 0 !important;
}

.slide {
	height: 100%;
	align-self: center;
}

.container-slider {
	padding: 0 20px;
}

@media only screen and (max-width: 768px) {
  h2 {
		margin-bottom: 25px;
	}
}
</style>
